import { Link } from "react-router-dom";
import "./Blog.css"
import Navbar from "../components/layout/Navbar";
import { Helmet } from "react-helmet-async";

export default function Blog() {
  return (
    <>
    <Helmet>
        <title>SpendSwitch Blog – Expense Tracking & Subscription Tips</title>
        <meta
          name="description"
          content="Guides and tips on expense tracking, subscription management, budgeting, and smarter spending with SpendSwitch."
        />
      </Helmet>
      
    <Navbar />
    
        <main className="blog-list">
      <h1>SpendSwitch Blog</h1>
      <p>Guides and tips to manage your spending better.</p>

      <Link
  to="/blog/best-expense-tracker-bank-statement-upload"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>Best Expense Tracker with Bank Statement Upload (2026 Guide)</h2>
    <p>
      Discover the best way to track expenses automatically using bank
      statement uploads and AI categorization.
    </p>
  </div>
</Link>

<Link
  to="/blog/analyze-bank-statements-automatically"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Analyze Bank Statements Automatically</h2>
    <p>
      Learn how to automatically analyze bank statements, detect spending
      patterns, and save hours of manual tracking.
    </p>
  </div>
</Link>

<Link
  to="/blog/track-expenses-from-bank-statement-pdf"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Track Expenses from Bank Statement PDFs</h2>
    <p>
      Upload your bank statement PDFs and instantly track, categorize, and
      understand your spending without manual effort.
    </p>
  </div>
</Link>

<Link
  to="/blog/maximize-credit-card-cashback"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Maximize Credit Card Cashback Automatically</h2>
    <p>
      Learn how to choose the right card for each category and maximize your
      cashback rewards automatically.
    </p>
  </div>
</Link>

<Link
  to="/blog/track-expenses-multiple-accounts"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Track Expenses Across Multiple Bank Accounts Easily</h2>
    <p>
      Learn how to manage multiple bank accounts and credit cards in one place
      with better financial insights.
    </p>
  </div>
</Link>


<Link
  to="/blog/ai-expense-categorization"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Categorize Expenses Automatically Using AI</h2>
    <p>
      Discover how AI can automatically categorize your transactions and
      improve your expense tracking accuracy.
    </p>
  </div>
</Link>

<Link
  to="/blog/why-you-are-always-broke"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>Why You’re Always Broke Even With a Good Salary</h2>
    <p>
      Discover the hidden reasons behind overspending and why your salary
      never feels enough.
    </p>
  </div>
</Link>

<Link
  to="/blog/find-hidden-subscriptions"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Find Hidden Subscriptions in Your Bank Statement</h2>
    <p>
      Discover hidden recurring charges, cancel unused subscriptions, and stop
      wasting money every month.
    </p>
  </div>
</Link>


      <Link to="/blog/how-to-track-subscriptions" className="blog-card-link">
        <div className="blog-card">
          <h2>How to Track Subscriptions and Cancel Unused Ones</h2>
          <p>
            Learn how to find forgotten subscriptions and stop wasting money
            every month.
          </p>
        </div>
      </Link>

<Link
  to="/blog/monthly-budget-guide"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Build a Monthly Budget That Actually Works</h2>
    <p>
      Learn how to create a realistic budget, track spending, and stay
      consistent with your financial goals.
    </p>
  </div>
</Link>

      <Link to="/blog/best-expense-tracker-for-students" className="blog-card-link">
        <div className="blog-card">
          <h2>Best Expense Tracker for Students</h2>
          <p>
            A simple guide for students to manage budgets, earn cashbacks,
            and track monthly expenses effectively.
          </p>
        </div>
      </Link>

      <Link
  to="/blog/stop-paying-for-forgotten-subscriptions"
  className="blog-card-link"
>
  <div className="blog-card">
    <h2>How to Stop Paying for Subscriptions You Forgot About</h2>
    <p>
      Find forgotten subscriptions, cancel unused recurring payments, and
      stop wasting money every month.
    </p>
  </div>
</Link>


    </main>
    </>
  );
}
